import { useState } from 'react'

import { useAppSelector } from 'app-redux/hooks'

import ToastService from 'services/toast.service'
import DeckService from 'services/deck.service'

import PhatButton from 'components/formElements/PhatButton'
import PhatInput from 'components/formElements/PhatInput'

import styles from './newSnapshotForm.module.scss'

type Props = {
  onCreated: () => void
  onCancel: () => void
  className?: string
}

const NewSnapshotForm = ({ onCreated, onCancel, className = '' }: Props) => {
  const deckName = useAppSelector(state => state.deck.name)
  const deckId = useAppSelector(state => state.deck.id)

  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [loading, setLoading] = useState(false)

  const handleCreateVersion = (e: React.FormEvent) => {
    e.preventDefault()

    if (!name) return ToastService.create('Deck snapshots need a name', 'Deck snapshots', 'error')

    DeckService.createSnapshot(deckId, { name, description })
      .then(() => {
        setName('')
        setDescription('')

        ToastService.create('Snapshot created', 'Deck snapshots', 'success')

        onCreated()
      })
      .catch(err => ToastService.create(err))
      .finally(() => setLoading(false))
  }

  return (
    <form onSubmit={handleCreateVersion} className={`${styles.form} ${className}`}>
      <label>Snapshot name</label>
      <PhatInput placeholder={`${deckName} 2.0`} onChange={setName} className={styles.input} focusOnMount />
      <label>Description</label>
      <textarea
        className={styles.textarea}
        placeholder="A brief description of the deck version"
        onChange={e => setDescription(e.target.value)}
      />
      <div className={styles.controls}>
        <PhatButton type="button" onClick={onCancel} color="red" disabled={loading}>
          Cancel
        </PhatButton>
        <PhatButton type="submit" onClick={handleCreateVersion} color="green" disabled={loading}>
          {loading ? 'Creating...' : 'Create snapshot'}
        </PhatButton>
      </div>
    </form>
  )
}

export default NewSnapshotForm
